import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions";

function AdminProducts() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://kolibusiness.com/backend/api-products.php")
      .then((res) => res.json())
      .then((data) => setProducts(data));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;

    const res = await fetch(`https://kolibusiness.com/backend/delete-product.php?id=${id}`);
    const result = await res.json();
    if (result.success) {
      alert("Product deleted");
      setProducts(products.filter((p) => p.id !== id));
    } else {
      alert("Delete failed: " + result.message);
    }
  };

  if (!hasPermission("products", "view")) {
    return (
      <AdminLayout>
        <p style={{ color: "red", padding: "20px", fontWeight: "bold" }}>
          ❌ You do not have permission to view products.
        </p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <h2 style={{ marginBottom: "20px" }}>🛍️ All Products</h2>

      {hasPermission("products", "edit") && (
        <button
          onClick={() => navigate("/admin/products/add")}
          style={styles.addButton}
        >
          ➕ Add Product
        </button>
      )}

      <div style={styles.grid}>
        {products.map((product) => (
          <div key={product.id} style={styles.card}>
            <img
              src={`https://kolibusiness.com/backend/uploads/${product.image}`}
              alt={product.title}
              style={{ width: "100%", height: "180px", objectFit: "cover" }}
            />
            <h3>{product.title}</h3>
            <p>₹{product.price}</p>
            {hasPermission("products", "edit") && (
              <div style={styles.actionButtons}>
                <button
                  style={styles.editButton}
                  onClick={() => navigate(`/admin/products/edit/${product.id}`)}
                >
                  ✏️ Edit
                </button>
                <button
                  style={styles.deleteButton}
                  onClick={() => handleDelete(product.id)}
                >
                  🗑️ Delete
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}

const styles = {
  addButton: {
    background: "#00b894",
    color: "white",
    padding: "10px 20px",
    borderRadius: "6px",
    border: "none",
    fontWeight: "bold",
    fontSize: "16px",
    cursor: "pointer",
    marginBottom: "20px"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "20px"
  },
  card: {
    background: "#fff",
    borderRadius: "8px",
    padding: "15px",
    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  actionButtons: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    marginTop: "10px"
  },
  editButton: {
    background: "#0984e3",
    color: "white",
    padding: "8px 14px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold"
  },
  deleteButton: {
    background: "#d63031",
    color: "white",
    padding: "8px 14px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold"
  }
};

export default AdminProducts;
